export async function simpleFetch<T>(url: string, options?: RequestInit): Promise<T> {
  const response = await fetch(url, options)

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(errorText)
  }

  const data: T = await response.json()
  return data
}
